function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".batterya{fill:#3b3b3b;}.batteryb{fill:#61d82c;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-9128.814 2533.272) rotate(-90)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2519.074 9128.814)"
}, /*#__PURE__*/React.createElement("path", {
  className: "batterya",
  d: "M2530.737,9160.823h-9.127a2.538,2.538,0,0,1-2.536-2.535v-15.321a2.539,2.539,0,0,1,2.536-2.536h9.127a2.539,2.539,0,0,1,2.536,2.536v15.321A2.538,2.538,0,0,1,2530.737,9160.823Zm-9.127-18.7a.846.846,0,0,0-.845.846v15.321a.846.846,0,0,0,.845.845h9.127a.846.846,0,0,0,.845-.845v-15.321a.846.846,0,0,0-.845-.846Z",
  transform: "translate(-2519.074 -9137.158)"
}), /*#__PURE__*/React.createElement("path", {
  className: "batterya",
  d: "M2537.941,9132.934h-1.69v-2.168a.264.264,0,0,0-.261-.26h-3.625a.264.264,0,0,0-.261.26v2.168h-1.69v-2.168a1.953,1.953,0,0,1,1.951-1.951h3.625a1.953,1.953,0,0,1,1.951,1.951Z",
  transform: "translate(-2527.219 -9128.814)"
})), /*#__PURE__*/React.createElement("rect", {
  className: "batteryb",
  width: 8,
  height: 15,
  transform: "translate(2522.272 9134.843)"
}));

var SvgBattery = function SvgBattery(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.665,
    height: 11.198,
    viewBox: "0 0 23.665 14.198",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBattery, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/battery.6eee1ea0.svg";
export { ForwardRef as ReactComponent };